import type { ReactNode } from "react";

export interface RowItem {
  key: string;
  label: string;
  value: ReactNode;
  /** Long values such as addresses read better stacked under their label. */
  stack?: boolean;
}

/** Label and value pairs used for allocation and launch read-outs. */
export function Rows({ items }: { items: RowItem[] }) {
  return (
    <dl className="rows">
      {items.map((item) => (
        <div
          className={item.stack ? "rows__row rows__row--stack" : "rows__row"}
          key={item.key}
        >
          <dt className="rows__key">{item.label}</dt>
          <dd className="rows__val">{item.value}</dd>
        </div>
      ))}
    </dl>
  );
}
